import { FaInstagram, FaLinkedin } from "react-icons/fa";

import { Link } from "react-router-dom";
import React from "react";
import styled from "styled-components";
import { useTypedResource } from "../i18n/languagehandler";

const Container = styled.footer`
  margin-top: 60px;
  padding: 32px 20px;
  background: #f7f9fc;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 20px;
  align-items: center;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Social = styled.div`
  display: flex;
  gap: 16px;
  a {
    color: var(--text);
    text-decoration: none;
  }
  a:hover {
    color: var(--primary);
    text-decoration: underline;
  }
`;

const Muted = styled.div`
  color: #6b7280;
  font-size: 14px;
`;

export const Footer: React.FC = () => {
  const res = useTypedResource<{
    impressum: string;
    contact: string;
    followUs: string;
    rights: string;
  }>("footer");
  return (
    <Container>
      <Inner>
        <Muted>
          © {new Date().getFullYear()} Aida Bikic — {res.rights}
        </Muted>
        <Social>
          <a
            href="https://www.instagram.com/aida.bikic/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            {React.createElement(
              FaInstagram as unknown as React.FC<{ size?: number }>,
              { size: 20 }
            )}
          </a>
          <a
            href="https://www.linkedin.com/in/aida-bikic/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            {React.createElement(
              FaLinkedin as unknown as React.FC<{ size?: number }>,
              { size: 20 }
            )}
          </a>
        </Social>
        <div style={{ display: "flex", gap: 16 }}>
          <Link to="/impressum">{res.impressum}</Link>
          <Link to="/contact">{res.contact}</Link>
        </div>
      </Inner>
    </Container>
  );
};
